import { Injectable, EventEmitter, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpEventType } from '@angular/common/http';
import { BehaviorSubject, Observable, Subscription, } from 'rxjs';
import { map, retry, switchMap, windowWhen } from 'rxjs/operators';
import { AlertController, LoadingController, MenuController, ModalController, NavController, Platform, ToastController } from '@ionic/angular';
import { LocalDbService } from './local-db.service';
import { formatDate, LocationStrategy } from '@angular/common';
import { AppEnum } from '../appenum';
import { ThemingService } from './theming.service';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from '../app.settings';
import { environment } from 'src/environments/environment';
import { EncryptionService } from './encryption.service';
import * as CryptoJS from 'crypto-js';
import { SelectLanguageComponent } from '../shared/select-language/select-language.component';
import { DomSanitizer } from '@angular/platform-browser';
import { IdbService } from './idb.service';
import { ModelPopupComponent } from '../shared/model-popup/model-popup.component';
import { LoggingService } from './logging.service';
import { wrapAllMethodsWithLogging } from '../core/decorators/log-all-errors.decorator';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  public isLanguageChanged = new BehaviorSubject(false);
  public BackClickEvent: any = false;
  public isBackButtonlicked = new EventEmitter(false);
  public apiUrl = `${environment.apiUrl}`;
  // private headersOption = new HttpHeaders();
  public connectionPopup = false;
  public disconnectSubscription;
  public connectSubscription;
  public isLoading = false;
  public isPrgressBarShow = false;
  // public isDataLoading = true;
  public currentScreenOrientation: string;
  public UploadMaxRetryHit = 3;
  public userName: any;
  public maskmobile: any;
  agentconnected = 0;

  secretKeyForDataEnc = "xT46emMu7wJpsQGe";  //key used in Python
  secretIVKeyForDataEnc = "U3U9lKwOGNTk0Rz8";

  public static currentDate = new Date().toISOString();
  public static dateFormat = "EEE MMM dd yyyy HH:mm:ss ZZZZ";

  level = this._appenum.EntityOfLogLevel.All;
  logWithDate: boolean = true;
  public inpOrgID = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.OrgId));
  public isDataLoading = new BehaviorSubject(true);
  showHeader = new BehaviorSubject(true);
  errorMessages: any;
  pinRequireText: any;
  pinMinLengthRequireText: any;
  minMaxLengthRequireText: any;
  lang: any;
  public isPrechecklistChange = new BehaviorSubject(false);
  isModalOpen: any = false;

  public staticLattitude: any = 28.6520; // Default latitude 
  public staticLongitude: any = 77.2315; // Default longitude
  public staticAccuracy: any = 20; // Default accuracy
  public static UploadMaxRetryHit = 3;
  public isLangDataLoading = new BehaviorSubject(false);
  componentName: any = 'app-service';

  constructor(public http: HttpClient, public _appenum: AppEnum,
    private _sanitizer: DomSanitizer,
    public _toastController: ToastController, private _menuCtrl: MenuController,
    public loadingController: LoadingController, public modalController: ModalController,
    public _alertController: AlertController, public _locationStrategy: LocationStrategy,
    public _translateService: TranslateService, public _appSetting: AppSettings,
    public idbservice: IdbService,
    private injector: Injector,
    public modalCtrl: ModalController,
    private _nav: NavController, public _localDbServices: LocalDbService, public _themingService: ThemingService,
    public encryptionService: EncryptionService) {
    wrapAllMethodsWithLogging(this, this.componentName, this.injector, LoggingService);
    // this.apiUrl = 'https://deyesinspectionservice-dq5rvo4msq-el.a.run.app/'; 
    this.lang = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale))
    this._translateService.use(this.lang);
    this._translateService.stream('error_message.pin_require_text').subscribe(res => {
      this.pinRequireText = res;
    })
    this._translateService.stream('error_message.pin_minlength_text').subscribe(res => {
      this.pinMinLengthRequireText = res;
    })
    this._translateService.stream('error_message.pin_maxlength_text').subscribe(res => {
      this.minMaxLengthRequireText = res;
    })

  }

  removeBackHistory(res: any, action: any) {
    history.pushState(null, null, location.href);
    this._locationStrategy.onPopState(() => {
      history.pushState(null, null, location.href);
      this.isBackButtonlicked.next({ result: res, doaction: action });
      setTimeout(() => {
        this.isBackButtonlicked.next(false);
      }, 200);
    });
  }

  unSubscriptiondisconnect() {
    this.disconnectSubscription.unsubscribe();
  }

  SubscriptionConnect() {
    this.connectSubscription.unsubscribe();
  }

  async storefilesData(fileUrl, fileType, TaskID, UserID, zoneDetails, ImgFileIdForAudio = null, MetaData = null) {
    const today = new Date();
    var fileName = TaskID + '_' + today.getTime().toString() + '.png';
    var postJson = {
      ImgFileIdForAudio: ImgFileIdForAudio,
      TaskID: TaskID,
      UserID: UserID,
      zoneDetails: zoneDetails,
      FileType: fileType,
      LocalFileUrl: fileUrl,
      FileSize: "",
      FileName: fileName,
      UploadStatus: 'false',
      RetryHitting: 0,
      MetaData: MetaData,
      ServerFileID: 0,
      ServerFileName: '',
      LiveUrl: '',
    }
    return await this._localDbServices.addInspectionFilesDetails(postJson);
  }

  async presentLoading(message = "") {
    if (!this.isLoading) {
      this.isLoading = true;
      return await this.loadingController.create({
        message: message == "" ? 'Please wait...' : message,
      }).then(a => {
        a.present().then(() => {
          if (!this.isLoading) {
            a.dismiss().then(() => null);
          }
        });
      });
    }
  }

  async loaderDismiss() {
    if (this.isLoading) {
      this.isLoading = false;
      return await this.loadingController.dismiss().then(() => null);
    }
  }

  get_filesDetails_audio_List = (itemsList, InspectionFileId = 0, link = 'ImgFileIdForAudio') =>
    itemsList.filter(item => item[link] == InspectionFileId).map(item => (
      { ...item, AudiosList: this.get_filesDetails_audio_List(itemsList, item.InspectionFileId) }
    ));

  async presentToast(msg, className = null) {
    const toast = await this._toastController.create({
      message: msg,
      duration: 2000,
      cssClass: className == null ? 'custom-toast' : 'custom-toast-error',
      position: 'top'
    });
    toast.present();
  }

  async getDataByPromiss(url): Promise<any> {
    url = this.apiUrl + url;
    return await this.http.get(url).pipe(retry(this.UploadMaxRetryHit)).toPromise();
  }

  async postDataWithPromise(url: string, data: any): Promise<any> {
    url = this.apiUrl + url;
    const encryptedPayload = { data: await this.encryptDataValues(JSON.stringify(data)) };
    const isValidToken = await this.checkTokenExpired();
    if (isValidToken) {
      var result: any = await this.http.post(url, encryptedPayload).pipe(retry(this.UploadMaxRetryHit)).toPromise();
      return this.decryptDataValues(result?.data)
    }
  }

  encryptDataValues(data) {
    var key = CryptoJS.enc.Utf8.parse(this.secretKeyForDataEnc);
    var iv = CryptoJS.enc.Utf8.parse(this.secretIVKeyForDataEnc)
    var encrypted: any = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC });
    encrypted = encrypted.toString();
    return encrypted.toString();
  }

  decryptDataValues(Base64CBC) {
    var iv = CryptoJS.enc.Utf8.parse(this.secretIVKeyForDataEnc);
    var key = CryptoJS.enc.Utf8.parse(this.secretKeyForDataEnc);
    var decrypted: any = CryptoJS.AES.decrypt(Base64CBC, key, { iv: iv, mode: CryptoJS.mode.CBC });
    decrypted = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  }

  getData(url): Observable<any> {
    url = this.apiUrl + url;
    return this.http.get(url)
      .pipe(retry(this.UploadMaxRetryHit), map(results => {
        return results;
      }, err => {
        alert(err.Message);
      }));
  }

  getDatafromExternalUrl(url): Observable<any> {
    return this.http.get(url)
      .pipe(retry(this.UploadMaxRetryHit), map(results => {
        return results;
      }, err => {
        alert(err.Message);
      }));
  }

  async postDataWithPromiseWithoutAuth(url, data): Promise<any> {
    var withOutAuth = new HttpHeaders();
    withOutAuth.append('Content-Type', 'application/json');
    withOutAuth.append('Access-Control-Allow-Headers', 'Content-Type');
    withOutAuth.append('Access-Control-Allow-Origin', '*');
    withOutAuth.append('ReqBodyenc', 'true');
    url = this.apiUrl + url;
    const encryptedPayload = { data: await this.encryptDataValues(JSON.stringify(data)) };
    var result: any = await this.http.post(url, encryptedPayload, { headers: withOutAuth, }).pipe(retry(this.UploadMaxRetryHit)).toPromise();
    return this.decryptDataValues(result?.data);
  }

  async postData(url: string, data: any): Promise<Observable<any>> {
    url = this.apiUrl + url;
    const encryptedPayload = { data: await this.encryptDataValues(JSON.stringify(data)) };
    const isValidToken = await this.checkTokenExpired();
    if (isValidToken) {
      return this.http.post(url, encryptedPayload).pipe(retry(this.UploadMaxRetryHit), map((results: any) => {
        return this.decryptDataValues(results?.data)
        return results;
      }, (err: { Message: any; }) => {
        alert(err.Message);
      }));
    }
  }

  async checkTokenExpired() {
    const authToken = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.authtoken));
    const newToken = JSON.parse(atob(authToken.split('.')[1]))
    const unixTimestamp = newToken.exp;
    const curUnixTimestamp = Math.floor(Date.now() / 1000);
    if (unixTimestamp > curUnixTimestamp) {
      return true;
    } else {
      return this.refreshToken().then(res => {
        return res;
      })
    }
  }

  async refreshToken(val = null): Promise<any> {
    var postJson = {
      "orgId": this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.OrgId)),
      "userId": this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.userid)),
      "accessToken": this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.authtoken)),
      "refreshToken": this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.refreshToken)),
      "sessionId": this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.sessionID)),
      "deviceId": this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.deviceId)),
    };
    return this.postDataWithPromiseWithoutAuth(environment.endpoint.getRefreshToken, postJson).then(async (res) => {
      if (res.StatusCode == 200) {
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.authtoken, res.Data[0].accessToken)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.refreshToken, res.Data[0].refreshToken)
        return true;
      } else {
        return false;
      }
    });
  }

  putJsonData(url, data): Observable<any> {
    url = this.apiUrl + url;
    return this.http.put(url, data)
      .pipe(retry(this.UploadMaxRetryHit), map(results => {
        return results;
      }, err => {
        alert(err.Message);
      }));
  }


  deleteData(url): Observable<any> {
    url = this.apiUrl + url;
    return this.http.delete(url)
      .pipe(retry(this.UploadMaxRetryHit), map(results => {
        return results;
      }, err => {
        alert(err.Message);
      }));
  }



  upload(url, fileData) {
    url = this.apiUrl + url;
    return this.http.post<any>(url, fileData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(map((event) => {
      switch (event.type) {
        case HttpEventType.UploadProgress:
          const progress = Math.round(100 * event.loaded / event.total);
          return { status: 'progress', message: progress };
        case HttpEventType.Response:
          return event.body;
        default:
          return `Unhandled event: ${event.type}`;
      }
    })
    );
  }

  asyncUpload(url, FileData): Promise<any> {
    url = this.apiUrl + url;
    return this.http.post(url, FileData, {
      reportProgress: true,
      observe: 'events'
    }).toPromise()
      .then(data => data)
      .catch((error: any) => {
      });
  }


  async ionicCustomAlert(title, Subtitle, msg) {
    const alert = await this._alertController.create({
      cssClass: 'ionic-Custom-alertBox',
      header: title,
      subHeader: Subtitle,
      message: msg,
      buttons: ['Ok']
    });

    await alert.present();
  }

  // show Menu
  showMenu() {
    this._menuCtrl.enable(true);
  }

  hideMenu() {
    this._menuCtrl.enable(false);
  }

  go_to_tasklist() {
    this._nav.navigateRoot(['/user-panel/tasks/task-list']);
  }

  //Time Zone Changes
  changeDateformat(inputDate) {
    return formatDate(inputDate, AppService.dateFormat, 'en-US', this.getTimeZoneOffset());
  }

  getTimeZoneOffset() {
    // return '+0530';
    return this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.zoneOffset));
  }

  getTimeZone() {
    // return 'Asia/Kolkata'
    return this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.timeZone));
  }


  private shouldLog(level: any): boolean {
    let ret: boolean = false;
    if ((level >= this.level && level !== this._appenum.EntityOfLogLevel.Off) || this.level === this._appenum.EntityOfLogLevel.All) {
      ret = true;
    }
    return ret;
  }

  // New Logging system activity
  async logsActivity(severity, logTextMsg, componentOrPage, httpRequest = null, taskDetails = null) {
    if (this.shouldLog(severity)) {
      var postJson = {
        severity: this._appenum.EntityOfLogLevel[severity],//"info/error/warning",
        logTextMsg: logTextMsg,
        logtime: new Date().toISOString(),
        userId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentid)) ? this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentid)) : null,
        sessionId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.sessionID)) ? this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.sessionID)) : null,
        deviceId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.deviceId)) ? this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.deviceId)) : null,
        deviceInfo: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.DeviceInfo)) ? this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.DeviceInfo)) : null,
        componentOrPage: 'Assisted PWA App | ' + componentOrPage,
        isonline: window.navigator.onLine,
        operationMode: 'Frontend Logs',
        httpRequest: {
          method: httpRequest ? httpRequest.method : null,
          Url: httpRequest ? httpRequest.url : null,
          payLoad: httpRequest ? httpRequest.payLoad : null,
          response: {
            responseCode: httpRequest ? httpRequest.response.responseCode : null,
            responseMsg: httpRequest ? httpRequest.response.responseMsg : null,
            result: httpRequest ? httpRequest.response.result : null,
          },
          // executionTime: ""
        },
        taskId: taskDetails ? taskDetails.TaskId : null,
        taskStatus: taskDetails ? taskDetails.status : null,
        taskFormControlDetails: taskDetails ? (taskDetails.controlDetail ? taskDetails.controlDetail : null) : null,
        // taskLocalFiles: taskDetails.fileDetails ? taskDetails.fileDetails : null
      }
      var postArray = []
      postArray.push(postJson);
      var res = {
        data: postArray
      }
      this.postDataWithPromiseWithoutAuth(environment.endpoint.directLogging, res).then(async (_res) => {

      }, err => {
        console.log(err);
      })
    }
  }


  showheaderOrNot(show: boolean) {
    setTimeout(() => {
      this.showHeader.next(show)
    }, 1000)
  }

  async setSiteLocale() {
    const languageArr = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.languageData));
    const selectedLanguageId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale))
    const obj = {
      component: SelectLanguageComponent,
      cssClass: 'my-custom-class1',
      componentProps: {
        languageArr,
        selectedLanguageId,
      },
    };
    const modal = await this.modalController.create(obj);
    await modal.present();


    const { data: languageSelected } = await modal.onWillDismiss();

    if (languageSelected?.selectedlanguage !== undefined) {
      const selectedLanguage = languageSelected.selectedlanguage;
      this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale, selectedLanguage);
      this._appSetting.selectedLanguage = selectedLanguage;
      this._translateService.use(selectedLanguage);
    } else {
      this._translateService.use(selectedLanguageId);
    }
    this.isPrechecklistChange.next(true);
    this.FormErrorMessages();
    this.changelanguage(true);
    // this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale, event.target.value);
    // this._appSetting.selectedLanguage = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale));
    // this._translateService.use(event.target.value)
    // this.FormErrorMessages();
  }

  changelanguage(val: any) {
    setTimeout(() => {
      this.isLanguageChanged.next(val);
    }, 100)
  }

  FormErrorMessages() {
    return this.errorMessages = {
      otp: [
        { type: 'required', message: this.pinRequireText },
        { type: 'minlength', message: this.pinMinLengthRequireText },
        { type: 'maxlength', message: this.minMaxLengthRequireText }
      ],
    }
  }

  // async storefilesDataAddressVerification(fileUrl, fileType, taskId, zoneDetails, ImgFileIdForAudio = null, MetaData = null, UploadStatus = 'false', ServerFileName = "") {
  //   const today = new Date();
  //   var fileName = fileUrl.name;
  //   var postJson = {
  //     ImgFileIdForAudio: ImgFileIdForAudio,
  //     taskId: taskId,
  //     // UserID: UserID,
  //     zoneDetails: zoneDetails,
  //     FileType: fileType,
  //     LocalFileUrl: fileUrl ? fileUrl : '',
  //     FileSize: "",
  //     FileName: fileName,
  //     UploadStatus: UploadStatus,
  //     RetryHitting: 0,
  //     MetaData: MetaData,
  //     ServerFileID: 0,
  //     ServerFileName: ServerFileName,
  //     LiveUrl: '',
  //   }
  //   return await this.idbservice.addressVerificationFilesDetails(postJson);
  // }

  async storefilesDataAddressVerification(
    file: Blob,
    fileType: string,
    taskId: string,
    zoneDetails: any = null,
    ImgFileIdForAudio: number | null = null,
    MetaData: string | null = null,
    fileName: any,
    UploadStatus: string = 'false',
    ServerFileName: string = ''
  ) {
    const safeBlob = new Blob([file], { type: file.type });
    const base64String = await this.blobToBase64(safeBlob);
    const postJson = {
      id: `${taskId}_${fileName}`, // unique ID
      ImgFileIdForAudio,
      taskId,
      FileName: fileName,
      FileType: fileType,
      FileSize: file.size,
      UploadStatus,
      RetryHitting: 0,
      MetaData,
      ServerFileID: 0,
      ServerFileName,
      LiveUrl: '',
      zoneDetails,
      base64image: base64String
    };
    return await this.idbservice.addressVerificationFilesDetails(postJson);
  }

  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      try {
        const reader = new FileReader();

        reader.onloadend = () => {
          if (typeof reader.result === 'string') {
            resolve(reader.result); // base64 string
          } else {
            const errorMsg = 'Failed to convert blob to base64';
            reject(errorMsg);
          }
        };

        reader.onerror = (err) => {
          reject(err);
        };

        reader.readAsDataURL(blob);
      } catch (error) {
        reject(error);
      }
    });
  }

  bypassSecurityTrustUrl(url) {
    return this._sanitizer.bypassSecurityTrustUrl(url);
  }
  async UploadByPromise(url: string, FileData: any): Promise<any> {
    url = this.apiUrl + url;
    return await this.http.post(url, FileData, { reportProgress: true, observe: 'events', }).toPromise()
  }
  unsubscribeIfExists(subscription: Subscription | undefined): void {
    if (subscription) {
      subscription.unsubscribe();
    }
  }

  setCookie(name: string, value: string, minutes: number, queryParam: string) {
    let expires = "";
    if (minutes) {
      const date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000); // Expiration time in milliseconds
      expires = "; expires=" + date.toUTCString();
    }
    // Store both token and query parameter as a structured JSON string
    const cookieValue = JSON.stringify({
      value: value,
      query: queryParam,
      taskId: this.getTabId()
    });
    const cookieName = `${name}_${this.getTabId()}`
    document.cookie = `${cookieName}=${encodeURIComponent(cookieValue)}${expires}; path=/`;
    // Set cookie with the structured value
    // document.cookie = `${name}=${encodeURIComponent(cookieValue)}${expires}; path=/`;
  }

  refreshAuthCookie(minutes = 15): void {
    const cookieName = `authToken_${this.getTabId()}`;
    const part = document.cookie.split('; ').find(c => c.startsWith(cookieName + '='));
    if (!part) return;                                   // expired or never logged in: do nothing
    const raw = part.substring(cookieName.length + 1);   // keep the stored value exactly as is
    const expires = new Date(Date.now() + minutes * 60 * 1000).toUTCString();
    document.cookie = `${cookieName}=${raw}; expires=${expires}; path=/`;
  }

  getCookie(name: string, queryParam: string) {
    const cookieName = `${name}_${this.getTabId()}`
    const nameEQ = cookieName + "=";
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length); // Clean spaces

      if (c.indexOf(nameEQ) === 0) {
        const cookieValue = c.substring(nameEQ.length, c.length);

        // Decode and parse the cookie value as JSON
        try {
          const parsedValue = JSON.parse(decodeURIComponent(cookieValue));

          // Ensure the query parameter in the cookie matches the current queryParam
          if (parsedValue.query === queryParam && parsedValue.taskId === this.getTabId()) {
            return parsedValue.value; // Return the token value
          } else {
            console.error('Cookie query parameter mismatch');
            return null; // Query parameter mismatch
          }
        } catch (error) {
          console.error('Error parsing cookie:', error);
          return null;
        }
      }
    }

    // No matching cookie found
    return null;
  }

  deleteCookie(name: string) {
    const cookieName = `${name}_${this.getTabId()}`
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }

  getTabId(): string {
    return sessionStorage.getItem('tabId') || '';
  }

  async ionicCustomPromptForCors(title, msg) {
    const alert = await this._alertController.create({
      cssClass: 'Confirmation_popup regularFonts',
      header: title,
      message: msg,
      buttons: [
        {
          text: 'OK',
          cssClass: ['confirmation_ok_button', 'confirmation_popup_button'],
          handler: async () => {
          }
        }
      ]
    });
    await alert.present();
  }

  async openModel(key: any) {
    if (this.isModalOpen) {
      return; // If modal is already open, do nothing
    }

    this.isModalOpen = true;
    var cls;
    var modelId = '';
    let addresses: any = [];
    if (key == 1) {
      cls = 'bottom-sheet-modal'
      addresses = JSON.parse(localStorage.getItem('addresshistory')),
        modelId = 'addressModel'
    } else if (key == 2) {
      cls = 'custom-modal'
    } else if (key == 3) {
      cls = 'congratulations-modal',
        modelId = 'timeoutModel'
    } else if (key == 4) {
      cls = 'custom-permission-model',
        modelId = 'permissionModel'
    }
    const obj = {
      component: ModelPopupComponent,
      id: modelId,
      cssClass: cls,
      componentProps: {
        key,
        addresses
      },
    };
    const modal = await this.modalCtrl.create(obj);
    await modal.present();

    const { data: languageSelected } = await modal.onWillDismiss();
    this.isModalOpen = false;
  }

  isValidJson(jsonstring) {
    return ((x) => { try { JSON.parse(x); return true; } catch (e) { return false } })(jsonstring)
  }

  async insertdummyblob(fileUrl) {
    const postJson = {
      blobData: fileUrl
    }
    return await this._localDbServices.insertdummyblob(postJson)
  }

  getTaskIdFromCookieByHashKey(name: string, hashKey: string): string | null {
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      // Check all cookies that start with name (authToken_)
      if (c.startsWith(`${name}_`)) {
        try {
          const raw = c.substring(c.indexOf('=') + 1);
          const parsed = JSON.parse(decodeURIComponent(raw));
          // Match by hashKey (query)
          if (parsed.query === hashKey) {
            return parsed.taskId || null;
          }
        } catch (e) {
          return null;
        }
      }
    }
    return null;
  }

  parseIOSVersion(ua: string): string {
    const match = ua.match(/OS\s([0-9_]+)\slike Mac OS X/);
    return match ? match[1].replace(/_/g, '.') : 'unknown';
  }

  parseIOSModel(ua: string): string {
    if (/iPad/.test(ua)) return 'iPad';
    if (/iPhone/.test(ua)) return 'iPhone';
    if (/iPod/.test(ua)) return 'iPod';
    return 'unknown';
  }

  parseAndroidVersion(ua: string): string {
    const match = ua.match(/Android\s([0-9.]+)/);
    return match ? match[1] : 'unknown'; // frozen as e.g. "10" on modern Chrome
  }

  parseAndroidModel(ua: string): string {
    const match = ua.match(/;\s([A-Za-z0-9\-_ ]+)\sBuild\//);
    return match ? match[1].trim() : 'unknown';
  }

  static getAppUrl() {
    return window.location.href
    // return "https://elevon-dev.assisted.digitaleyes.app?5F205";
  }
} 
